import { EventEmitter } from '@angular/core';

export abstract class AppAbstractDirective {

    constructor(
    ) {
    }

  // -------------------------------------------------------------------------
  // devuelve si se ha definido un metodo o no
  public isMethodEnabled(event: EventEmitter<any>): boolean {
    if (event.observers.length === 0) {
      return false;
    } else {
      return true;
    }
  }

}
